import { ProjectModels } from '../models/projects/project.models';
import { ProjectResponses } from '../responses';
import { BaseMapper } from './base-mapper';
export class ProjectMapper extends BaseMapper {
    mapProjectValidationIssuesListResponse(response) {
        return new ProjectResponses.ProjectValidationIssuesListResponse(super.mapResponseDebug(response), response.data, {
            items: response.data.issues.map((m) => this.mapProjectValidationIssue(m)),
            pagination: super.mapPagination(response.data.pagination)
        });
    }
    mapStartProjectValidationResponse(response) {
        return new ProjectResponses.StartProjectValidationResponse(super.mapResponseDebug(response), response.data, {
            id: response.data.id,
            status: response.data.status,
            validation_result: response.data.validation_result
        });
    }
    mapCheckProjectValidationResponse(response) {
        return new ProjectResponses.CheckProjectValidationResponse(super.mapResponseDebug(response), response.data, {
            id: response.data.id,
            status: response.data.status,
            validation_result: response.data.validation_result
        });
    }
    mapValidateProjectContentResponse(response) {
        return new ProjectResponses.ValidateProjectContentResponse(super.mapResponseDebug(response), response.data, {
            project: this.mapProjectModel(response.data.project),
            typeIssues: response.data.type_issues.map((m) => this.mapTypeIssue(m)),
            variantIssues: response.data.variant_issues.map((m) => this.mapVariantIssue(m))
        });
    }
    mapProjectInformationResponse(response) {
        return new ProjectResponses.ProjectInformationResponse(super.mapResponseDebug(response), response.data, {
            project: new ProjectModels.ProjectInformationModel(response.data.id, response.data.name, response.data.environment)
        });
    }
    mapProjectModel(raw) {
        return new ProjectModels.ProjectReportModel(raw.id, raw.name);
    }
    mapTypeModel(raw) {
        return new ProjectModels.ProjectTypeModel(raw.id, raw.name, raw.codename);
    }
    mapItemModel(raw) {
        return new ProjectModels.ProjectVariantContentItemModel(raw.id, raw.name, raw.codename);
    }
    mapLanguageModel(raw) {
        return new ProjectModels.ProjectVariantLanguageModel(raw.id, raw.name, raw.codename);
    }
    mapIssueModel(raw) {
        return new ProjectModels.ProjectIssueModel(this.mapVariantElementModel(raw.element), raw.messages);
    }
    mapTypeIssue(raw) {
        return new ProjectModels.ProjectTypeIssueModel(this.mapTypeModel(raw.type), raw.issues.map((m) => this.mapIssueModel(m)));
    }
    mapVariantIssue(raw) {
        return new ProjectModels.ProjectVariantIssueModel(this.mapItemModel(raw.item), this.mapLanguageModel(raw.language), raw.issues.map((m) => this.mapIssueModel(m)));
    }
    mapVariantElementModel(raw) {
        return new ProjectModels.ProjectVariantElementModel(raw.id, raw.name, raw.codename);
    }
    mapProjectValidationIssue(raw) {
        return new ProjectModels.ProjectValidationIssueModel(raw.issue_type, this.mapItemModel(raw.item), this.mapLanguageModel(raw.language), raw.issues.map((m) => this.mapIssueModel(m)));
    }
}
export const projectMapper = new ProjectMapper();
//# sourceMappingURL=project-mapper.js.map